export const allStaffStyle = {
  banner: require("@/assets/images/staffstyle/bg.png"),
  personstyle: {
    year_2023: {
      windAndRain: {
        name: "风雨同舟",
        dataList: [],
      },
      newModelWorker: {
        name: "新劳模",
        dataList: [],
      },
      newYouth: {
        name: "新青年",
        dataList: [],
      },
      fineStaff: {
        name: "优秀员工",
        dataList: [],
      },
    },
    year_2022: {
      windAndRain: {
        name: "风雨同舟",
        typeKey: "windAndRain",
        dataList: [
          {
            id: 1,
            name: "董国良",
            seniority: "28年",
            job: "库课科技董事长、天一镕尚品牌创始人",
            glory: "2022年度风雨同舟奖",
            motto: "为天下学子成就美好人生",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/1_windAndRain_dgl.png"),
          },
          {
            id: 2,
            name: "范贺民",
            seniority: "28年",
            job: "总裁办督导部",
            glory: "2022年度风雨同舟奖",
            motto: "认真负责为学生,踏踏实实做事情",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/2_windAndRain_fhm.png"),
          },
          {
            id: 3,
            name: "杨俊梅",
            seniority: "18年",
            job: "图书运营中心印务经理",
            glory: "2022年度风雨同舟奖",
            motto: "不念过往,不惧将来",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/3_windAndRain_yjm.png"),
          },
          {
            id: 4,
            name: "曹绍克",
            seniority: "17年",
            job: "图书运营中心录排专员",
            glory: "2022年度风雨同舟奖",
            motto: "开心工作,快乐生活!",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/4_windAndRain_csk.png"),
          },
          {
            id: 5,
            name: "陈小勇",
            seniority: "17年",
            job: "库课科技副总裁",
            glory: "2022年度风雨同舟奖",
            motto: "未来形成于今天",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/5_windAndRain_cxy.png"),
          },
          {
            id: 6,
            name: "王幸臣",
            seniority: "16年",
            job: "总裁办资深顾问",
            glory: "2022年度风雨同舟奖",
            motto: "责任是基因,奉献是一种信仰!",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/6_windAndRain_wxc.png"),
          },
          {
            id: 7,
            name: "薛晓辉",
            seniority: "15年",
            job: "图书运营中心录排专员",
            glory: "2022年度风雨同舟奖",
            motto: "不求事事顺心,但求无愧于心",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/7_windAndRain_xxh.png"),
          },
          {
            id: 8,
            name: "姚锐",
            seniority: "14年",
            job: "图书运营中心录排专员",
            glory: "2022年度风雨同舟奖",
            motto: "环境不会改变,解决之道在于改变自己",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/8_windAndRain_yr.png"),
          },
          {
            id: 9,
            name: "郭敏",
            seniority: "13年",
            job: "图书运营中心印务助理",
            glory: "2022年度风雨同舟奖",
            motto: "心气平和,事理通达",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/9_windAndRain_gm.png"),
          },
          {
            id: 10,
            name: "韩闯",
            seniority: "13年",
            job: "图书运营中心图书营销部副总监",
            glory: "2022年度风雨同舟奖",
            motto: "既然选择了远方,便只顾风雨兼程",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/10_windAndRain_hc.png"),
          },
          {
            id: 11,
            name: "潘颖颖",
            seniority: "13年",
            job: "图书运营中心录排专员",
            glory: "2022年度风雨同舟奖",
            motto: "越努力,越幸运!",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/11_windAndRain_pyy.png"),
          },
          {
            id: 12,
            name: "肖小红",
            seniority: "13年",
            job: "图书运营中心录排专员",
            glory: "2022年度风雨同舟奖",
            motto: "积极人生,全力以赴!",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/12_windAndRain_xxh.png"),
          },
          {
            id: 13,
            name: "张静",
            seniority: "13年",
            job: "图书运营中心录排经理",
            glory: "2022年度风雨同舟奖",
            motto: "没有等出来的成功,只有干出来的精彩",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/13_windAndRain_zj.png"),
          },
          {
            id: 14,
            name: "王广法",
            seniority: "12年",
            job: "专升本事业部VIP教学中心教学督导室",
            glory: "2022年度风雨同舟奖",
            motto: "要想仰望星空,须先脚踏实地",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/14_windAndRain_wgf.png"),
          },
          {
            id: 15,
            name: "袁冰寒",
            seniority: "12年",
            job: "专升本事业部VIP教学中心后勤副经理",
            glory: "2022年度风雨同舟奖",
            motto: "语言代替不了行动,行动才是最响亮的语言",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/15_windAndRain_ybh.png"),
          },
          {
            id: 16,
            name: "赵颖俐",
            seniority: "12年",
            job: "图书运营中心录排专员",
            glory: "2022年度风雨同舟奖",
            motto: "纵有疾风起，人生不言弃",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/16_windAndRain_zyl.png"),
          },
          {
            id: 17,
            name: "李志开",
            seniority: "11年",
            job: "图书运营中心图书业务部销售主管",
            glory: "2022年度风雨同舟奖",
            motto: "只为成功想方法,不为失败找借口",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/17_windAndRain_lzk.png"),
          },
          {
            id: 18,
            name: "张景怡",
            seniority: "11年",
            job: "专升本事业部市场部新媒体运营",
            glory: "2022年度风雨同舟奖",
            motto: "上坡要努力,下坡要开心",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/18_windAndRain_zjy.png"),
          },
          {
            id: 19,
            name: "李文玲",
            seniority: "11.5年",
            job: "专升本教学研究院教务部经理",
            glory: "2022年度风雨同舟奖",
            motto: "路虽远,行则将至,事虽难,做则必成",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/19_windAndRain_lwl.png"),
          },
          {
            id: 20,
            name: "莫娟娟",
            seniority: "10年",
            job: "教师教研中心心理学教研主管",
            glory: "2022年度风雨同舟奖",
            motto: "只要路是对的,就不怕路远",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/20_windAndRain_mjj.png"),
          },
          {
            id: 21,
            name: "张晓静",
            seniority: "10年",
            job: "图书运营中心图书策划生产部副总监",
            glory: "2022年度风雨同舟奖",
            motto: "对未来最好的策划,是善于处理目前,完成最近的工作任务",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/21_windAndRain_zxj.png"),
          },
          {
            id: 22,
            name: "赵霞",
            seniority: "10年",
            job: "教师教研中心教研总监",
            glory: "2022年度风雨同舟奖",
            motto: "能量守恒,力用在哪里，哪里就会有结果",
            img: require("@/assets/images/staffstyle/personstyle/2022/windAndRain/22_windAndRain_zx.png"),
          },
        ],
      },
      newModelWorker: {
        name: "新劳模",
        typeKey: "newModelWorker",
        dataList: [
          {
            id: 1,
            name: "范淑娜",
            seniority: "5.3年",
            job: "专升本教学研究院培训部培训主管",
            glory: "劳动新模范",
            motto: "态度决定一切，坚持才会胜利",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/1_newModelWorker_fsn.png"),
          },
          {
            id: 2,
            name: "高晓成",
            seniority: "3.4年",
            job: "专升本教学研究院管理学讲师",
            glory: "劳动新模范",
            motto: "认真负责为学生,乐业，爱业，敬业",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/2_newModelWorker_gxc.png"),
          },
          {
            id: 3,
            name: "郭贺",
            seniority: "7.3年",
            job: "专升本网校项目部网课制作组主管",
            glory: "劳动新模范",
            motto: "你必须非常的努力，才能都看起来毫不费力",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/3_newModelWorker_gh.png"),
          },
          {
            id: 4,
            name: "韩科峰",
            seniority: "3年",
            job: "图书运营中心仓库管理员",
            glory: "劳动新模范",
            motto: "天道酬勤",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/4_newModelWorker_hkf.png"),
          },
          {
            id: 5,
            name: "霍倩博",
            seniority: "3.9年",
            job: "人力资源中心薪酬绩效主管",
            glory: "劳动新模范",
            motto: "锻炼是成长、磨练是成才，都值得被铭记",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/5_newModelWorker_hqb.png"),
          },
          {
            id: 6,
            name: "焦慧",
            seniority: "2年",
            job: "教师事业部网校销售主管",
            glory: "劳动新模范",
            motto: "人因平凡而努力，因努力而不平凡!我要做不平凡的人!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/6_newModelWorker_jh.png"),
          },
          {
            id: 7,
            name: "李嘉颖",
            seniority: "5年",
            job: "图书运营中心产品策划经理",
            glory: "劳动新模范",
            motto: "只要朝着阳光，便不会看见阴影",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/7_newModelWorker_ljy.png"),
          },
          {
            id: 8,
            name: "李永杰",
            seniority: "6.8年",
            job: "专升本事业部市场部招生三部",
            glory: "劳动新模范",
            motto: "天道酬勤，自强不息",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/8_newModelWorker_lyj.png"),
          },
          {
            id: 9,
            name: "刘辉",
            seniority: "4.2年",
            job: "专升本事业部市场部招生五部",
            glory: "劳动新模范",
            motto: "别在该奋斗的年纪选择安逸",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/9_newModelWorker_lh.png"),
          },
          {
            id: 10,
            name: "刘会",
            seniority: "3年",
            job: "图书运营中心心理学策划",
            glory: "劳动新模范",
            motto: "当下拼尽全力，往后不留遗憾",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/10_newModelWorker_lh.png"),
          },
          {
            id: 11,
            name: "柳莹莹",
            seniority: "2.1年",
            job: "专升本事业部VIP教学中心新田校区教务主管",
            glory: "劳动新模范",
            motto: "工作要积极，处事要谦和",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/11_newModelWorker_lyy.png"),
          },
          {
            id: 12,
            name: "孙玉荣",
            seniority: "6年",
            job: "行政管理中心经理",
            glory: "劳动新模范",
            motto: "奋斗引领风尚，奉献是一种信仰",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/12_newModelWorker_syr.png"),
          },
          {
            id: 13,
            name: "王光庆",
            seniority: "6年",
            job: "专升本教学研究院高数讲师",
            glory: "劳动新模范",
            motto: "不为失败找借口只为成功找方法",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/13_newModelWorker_wgq.png"),
          },
          {
            id: 14,
            name: "王幸臣",
            seniority: "16年",
            job: "总裁办资深顾问",
            glory: "劳动新模范、风雨同舟",
            motto: "责任是基因，奉献是一种信仰!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/14_newModelWorker_wxc.png"),
          },
          {
            id: 15,
            name: "武帅伟",
            seniority: "2.1年",
            job: "专升本事业部市场部招生四部",
            glory: "劳动新模范",
            motto: "尽最大的努力,持最佳的态度,做最坏的打算",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/15_newModelWorker_wsw.png"),
          },
          {
            id: 16,
            name: "肖志魁",
            seniority: "4年",
            job: "专升本教学研究院线下英语讲师",
            glory: "劳动新模范",
            motto:
              "优雅需要底气，华丽需要实力，淡定的背后，一定是不断地坚持和努力",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/16_newModelWorker_xzk.png"),
          },
          {
            id: 17,
            name: "杨胜华",
            seniority: "2年",
            job: "图书运营中心专升本英语课程策划",
            glory: "劳动新模范",
            motto: "不是看到希望才坚持，是坚持才有希望",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/17_newModelWorker_ysh.png"),
          },
          {
            id: 18,
            name: "银豪",
            seniority: "2.6年",
            job: "专升本网校市场部销售一部",
            glory: "劳动新模范",
            motto: "凡是自强不息者，最终都会成功",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/18_newModelWorker_yh.png"),
          },
          {
            id: 19,
            name: "张宝文",
            seniority: "8年",
            job: "教师事业部VIP教学中心主任",
            glory: "劳动新模范",
            motto: "志在心中，路在脚下，把握现在，赢在未来",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/19_newModelWorker_zbw.png"),
          },
          {
            id: 20,
            name: "张贵勇",
            seniority: "4.1年",
            job: "专升本事业部市场部南阳分校校长",
            glory: "劳动新模范",
            motto: "脚踏实地，仰望星空",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/20_newModelWorker_zgy.png"),
          },
          {
            id: 21,
            name: "张梦恒",
            seniority: "8.9年",
            job: "专升本事业部VIP教学中心北大学城执行校长",
            glory: "劳动新模范",
            motto: "扶摇直上，不坠青云之志",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/21_newModelWorker_zmh.png"),
          },
          {
            id: 22,
            name: "张冉",
            seniority: "3.4年",
            job: "专升本教学研究院管理学讲师",
            glory: "劳动新模范",
            motto: "乐业，爱业，敬业",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/22_newModelWorker_zr.png"),
          },
          {
            id: 23,
            name: "张双双",
            seniority: "6.6年",
            job: "专升本事业部市场部课程咨询部",
            glory: "劳动新模范",
            motto: "越努力越幸运",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/23_newModelWorker_zss.png"),
          },
          {
            id: 24,
            name: "张文超",
            seniority: "5年",
            job: "教师事业部教师招聘笔试讲师",
            glory: "劳动新模范",
            motto: "教着，感受着;,走着，快乐着!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/24_newModelWorker_zwc.png"),
          },
          {
            id: 25,
            name: "朱芳缘",
            seniority: "6年",
            job: "教师事业部网校教研主管",
            glory: "劳动新模范",
            motto: "不经历风雨怎能见彩虹!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newModelWorker/25_newModelWorker_zfy.png"),
          },
        ],
      },
      newYouth: {
        name: "新青年",
        typeKey: "newYouth",
        dataList: [
          {
            id: 1,
            name: "陈黑",
            seniority: "2年",
            job: "图书运营中心专升本数学策划",
            glory: "库课新青年",
            motto: "了解过去，活在当下，展望未来",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/1_newYouth_ch.png"),
          },
          {
            id: 2,
            name: "丁莹莹",
            seniority: "4.11年",
            job: "专升本事业部VIP教学中心新田校区",
            glory: "库课新青年",
            motto: "任何事，必作于细，也必成于实",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/2_newYouth_dyy.png"),
          },
          {
            id: 3,
            name: "段志博",
            seniority: "9.7年",
            job: "专升本事业部市场部副总监",
            glory: "库课新青年",
            motto: "一路前行，初心不改",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/3_newYouth_dzb.png"),
          },
          {
            id: 4,
            name: "范刘闯",
            seniority: "3.5年",
            job: "品牌中心视频剪辑",
            glory: "库课新青年",
            motto: "只要努力一切皆有可能，相信自己终能创造奇迹",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/4_newYouth_flc.png"),
          },
          {
            id: 5,
            name: "付嫣然",
            seniority: "2.7年",
            job: "专升本教学研究院线上英语讲师",
            glory: "库课新青年",
            motto: "身外障碍事小，身内障碍事大",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/5_newYouth_fyr.png"),
          },
          {
            id: 6,
            name: "晋蓓蓓",
            seniority: "1年",
            job: "人力资源中心招聘配置部",
            glory: "库课新青年 卓越员工",
            motto: "人生在勤，不索何获",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/6_newYouth_jbb.png"),
          },
          {
            id: 7,
            name: "孔博楠",
            seniority: "3.4年",
            job: "专升本事业部VIP教学中心创新校区",
            glory: "库课新青年",
            motto: "路虽远，行则将至",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/7_newYouth_kbn.png"),
          },
          {
            id: 8,
            name: "李佳飞",
            seniority: "1.6年",
            job: "技术开发中心PHP开发工程师",
            glory: "库课新青年 卓越工程师",
            motto: "信念和目标必须永远洋溢在程序员内心",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/8_newYouth_ljf.png"),
          },
          {
            id: 9,
            name: "李佳欣",
            seniority: "4.5年",
            job: "专升本教学研究院线上英语讲师",
            glory: "库课新青年",
            motto: "学习的境界: 为知，为己，为人",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/9_newYouth_ljx.png"),
          },
          {
            id: 10,
            name: "李近近",
            seniority: "3年",
            job: "专升本教学研究院讲师",
            glory: "库课新青年",
            motto: "坚持启发式，避免注入式",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/10_newYouth_ljj.png"),
          },
          {
            id: 11,
            name: "李敏",
            seniority: "1.6年",
            job: "技术开发中心B端产品经理",
            glory: "库课新青年 卓越工程师",
            motto: "合理安排时间，就等于节约时间",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/11_newYouth_lm.png"),
          },
          {
            id: 12,
            name: "李晓双",
            seniority: "3年",
            job: "专升本事业部山东分校招生组长",
            glory: "库课新青年",
            motto: "做真诚的人，干漂亮的事，传递爱与正能量!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/12_newYouth_lxs.png"),
          },
          {
            id: 13,
            name: "刘通",
            seniority: "3.8年",
            job: "专升本网校文案策划",
            glory: "库课新青年",
            motto: "挟飞仙以遨游，抱明月而长终",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/13_newYouth_lt.png"),
          },
          {
            id: 14,
            name: "刘宪梅",
            seniority: "1.7年",
            job: "专升本教学研究院线上教学教研部经理",
            glory: "库课新青年",
            motto: "走过干山万水，仍怀赤子之心",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/14_newYouth_lxm.png"),
          },
          {
            id: 15,
            name: "刘晓辉",
            seniority: "5年",
            job: "品牌中心设计部经理",
            glory: "库课新青年",
            motto: "不要让挫折感把你吞噬，你就一定会成功",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/15_newYouth_lxh.png"),
          },
          {
            id: 16,
            name: "马礼姱",
            seniority: "2.5年",
            job: "河北分校",
            glory: "库课新青年",
            motto: "追光的人，终会光芒万丈!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/16_newYouth_mlk.png"),
          },
          {
            id: 17,
            name: "毛付先",
            seniority: "1.5年",
            job: "专升本网校项目部销售主管",
            glory: "库课新青年",
            motto: "没有失败，只有半途而废",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/17_newYouth_mfx.png"),
          },
          {
            id: 18,
            name: "彭红超",
            seniority: "1.5年",
            job: "广东分校招生组长",
            glory: "库课新青年",
            motto: "所谓的天花板就是没有天花板，不断突破，勇攀高峰",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/18_newYouth_phc.png"),
          },
          {
            id: 19,
            name: "秦艳婷",
            seniority: "2.5年",
            job: "专升本事业部市场部业务内勤",
            glory: "库课新青年",
            motto: "少说话，多做事，凡事有着落，事事有交代",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/19_newYouth_qyt.png"),
          },
          {
            id: 20,
            name: "万梦飞",
            seniority: "1年",
            job: "教师事业部教育学督学师",
            glory: "库课新青年",
            motto: "去更远的地方，追更亮的光",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/20_newYouth_wmf.png"),
          },
          {
            id: 21,
            name: "王彩霞",
            seniority: "4.5年",
            job: "图书运营中心高考历史组长",
            glory: "库课新青年",
            motto: "跌倒不丢人，每次跌倒后能再站起来，才是最大的荣耀",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/21_newYouth_wcx.png"),
          },
          {
            id: 22,
            name: "王蒙",
            seniority: "5年",
            job: "教师事业部市场部驻马店分校校长",
            glory: "库课新青年",
            motto: "越努力，越幸运!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/22_newYouth_wm.png"),
          },
          {
            id: 23,
            name: "王青青",
            seniority: "2年",
            job: "专升本教学研究院学科主管",
            glory: "库课新青年",
            motto: "用心做事，用爱育人",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/23_newYouth_wqq.png"),
          },
          {
            id: 24,
            name: "王增产",
            seniority: "1.7年",
            job: "专升本教学研究院英语讲师",
            glory: "库课新青年",
            motto: "有志者事竟成",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/24_newYouth_wzc.png"),
          },
          {
            id: 25,
            name: "王子胜",
            seniority: "2年",
            job: "技术开发中心总监",
            glory: "库课新青年",
            motto: "德不优者不能怀远，才不大者不能博见!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/25_newYouth_wzs.png"),
          },
          {
            id: 26,
            name: "魏小虎",
            seniority: "6.1年",
            job: "专升本事业部市场部业务招生副经理",
            glory: "库课新青年",
            motto: "做难事必有所得!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/26_newYouth_wxh.png"),
          },
          {
            id: 27,
            name: "吴星",
            seniority: "4年",
            job: "教师事业部教师教研中心心理学讲师",
            glory: "库课新青年",
            motto: "你来人间一趟，你要看看太阳!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/27_newYouth_wx.png"),
          },
          {
            id: 28,
            name: "肖世誉",
            seniority: "6年",
            job: "教师事业部市场部郑州总校",
            glory: "库课新青年 优秀校长",
            motto: "不抛弃 不放弃!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/28_newYouth_xsy.png"),
          },
          {
            id: 29,
            name: "张娟",
            seniority: "7年",
            job: "财务管理中心出纳",
            glory: "库课新青年",
            motto: "梦想藏在心里，行动落于脚下!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/29_newYouth_zj.png"),
          },
          {
            id: 30,
            name: "张伟",
            seniority: "3.9年",
            job: "专升本网校项目部副总监",
            glory: "库课新青年",
            motto: "成长是一生的追求",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/30_newYouth_zw.png"),
          },
          {
            id: 31,
            name: "张晓清",
            seniority: "5年",
            job: "总裁办政府项目部",
            glory: "库课新青年",
            motto: "凡事内敛，化于万物，不与众殊!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/31_newYouth_zxq.png"),
          },
          {
            id: 32,
            name: "张旭",
            seniority: "3年",
            job: "专升本教学研究院讲师",
            glory: "库课新青年",
            motto: "教学相长",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/32_newYouth_zx.png"),
          },
          {
            id: 33,
            name: "张亚菲",
            seniority: "4年",
            job: "专升本教学研究院学科组长",
            glory: "库课新青年",
            motto: "德高为师，身正为范",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/33_newYouth_zyf.png"),
          },
          {
            id: 34,
            name: "张雨欣",
            seniority: "2.5年",
            job: "图书运营中心专升本英语策划",
            glory: "库课新青年",
            motto: "慎于思考、勤于工作、严于律己!",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/34_newYouth_zyx.png"),
          },
          {
            id: 35,
            name: "郑可",
            seniority: "2年",
            job: "学历提升部",
            glory: "库课新青年",
            motto: "北海虽赊，扶摇可接",
            img: require("@/assets/images/staffstyle/personstyle/2022/newYouth/35_newYouth_zk.png"),
          },
        ],
      },
      fineStaff: {
        name: "优秀员工",
        typeKey: "fineStaff",
        dataList: [
          {
            id: 1,
            name: "郜利利",
            seniority: "9年",
            job: "高数教研员",
            glory: "优秀员工",
            motto: "学如逆水行舟，不进则退",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/1_fineStaff_gll.png"),
          },
          {
            id: 2,
            name: "常文婷",
            seniority: "1年",
            job: "品牌中心短视频运营",
            glory: "优秀员工",
            motto: "无需借光，自己本身就是太阳",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/2_fineStaff_cwt.png"),
          },
          {
            id: 3,
            name: "陈雨瑶",
            seniority: "1.5年",
            job: "专升本网校市场部销售一部",
            glory: "优秀员工",
            motto: "一分耕耘，一分收获",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/3_fineStaff_cyy.png"),
          },
          {
            id: 4,
            name: "程方",
            seniority: "3年",
            job: "专升本教学研究院讲师",
            glory: "优秀员工",
            motto: "打铁要趁热，学习要趁早",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/4_fineStaff_cf.png"),
          },
          {
            id: 5,
            name: "丁逢",
            seniority: "1年",
            job: "专升本教学研究院讲师",
            glory: "优秀员工",
            motto: "满腔赤诚，甘将心血化时雨;鞠躬尽疼，敬业爱生育英才",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/5_fineStaff_df.png"),
          },
          {
            id: 6,
            name: "范蕊",
            seniority: "2.5年",
            job: "图书运营中心教育学策划",
            glory: "优秀员工",
            motto: "使时间充实就是幸福",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/6_fineStaff_fr.png"),
          },
          {
            id: 7,
            name: "高旭辉",
            seniority: "2.3年",
            job: "技术开发中心PHP开发工程师",
            glory: "优秀员工",
            motto: "做好事情唯一的方法是爱你所做的事",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/7_fineStaff_gxh.png"),
          },
          {
            id: 8,
            name: "郭超强",
            seniority: "1年",
            job: "技术开发中心测试工程师",
            glory: "优秀员工",
            motto: "我是一切根源",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/8_fineStaff_gcq.png"),
          },
          {
            id: 9,
            name: "郭航月",
            seniority: "2年",
            job: "专升本教学研究院内训师",
            glory: "优秀员工",
            motto:
              "用精彩的课堂，开启新师智慧的大门;用不懈的努力，铺就教师成长的道路",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/9_fineStaff_ghy.png"),
          },
          {
            id: 10,
            name: "郭天",
            seniority: "1.5年",
            job: "专升本教学研究院排课专员",
            glory: "优秀员工",
            motto: "好好工作，好好生活",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/10_fineStaff_gt.png"),
          },
          {
            id: 11,
            name: "贾晓燕",
            seniority: "4年",
            job: "总裁办政府项目部",
            glory: "优秀员工",
            motto: "心胸坦荡，才可以拥抱阳光",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/11_fineStaff_jxy.png"),
          },
          {
            id: 12,
            name: "康兰宁",
            seniority: "1.5年",
            job: "校企合作项目部新媒体运营讲师",
            glory: "优秀员工",
            motto: "博观而约取，厚积而薄发",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/12_fineStaff_kln.png"),
          },
          {
            id: 13,
            name: "李佳霏",
            seniority: "1.5年",
            job: "四川分校综合管理部",
            glory: "优秀员工",
            motto: "岂能尽人如意，但求无愧于心",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/13_fineStaff_ljf.png"),
          },
          {
            id: 14,
            name: "李铉斌",
            seniority: "2年",
            job: "技术开发中心UED设计主管",
            glory: "优秀员工",
            motto: "傲不可长，欲不可纵，乐不可极，志不可满",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/14_fineStaff_lxb.png"),
          },
          {
            id: 15,
            name: "李腾飞",
            seniority: "7年",
            job: "教师事业部教师教研中心",
            glory: "优秀员工",
            motto: "当我在追光，我与光同航",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/15_fineStaff_ltf.png"),
          },
          {
            id: 16,
            name: "李振召",
            seniority: "3年",
            job: "专升本事业部市场部招生三部",
            glory: "优秀员工",
            motto: "脚踏实地，勇攀高峰",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/16_fineStaff_lzz.png"),
          },
          {
            id: 17,
            name: "刘超",
            seniority: "9.5年",
            job: "专升本网校项目部网课制作组",
            glory: "优秀员工",
            motto: "勤能补拙是良训，一分耕耘一分才",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/17_fineStaff_lc.png"),
          },
          {
            id: 18,
            name: "刘星汝",
            seniority: "6.2年",
            job: "专升本事业部市场部招生五部",
            glory: "优秀员工",
            motto: "山高人为峰，努力定成功",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/18_fineStaff_lxr.png"),
          },
          {
            id: 19,
            name: "刘雪敏",
            seniority: "1.5年",
            job: "教师事业部销售",
            glory: "优秀员工",
            motto: "沧海横流，方显英雄本色，乘风破浪更知壮志凌云",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/19_fineStaff_lxm.png"),
          },
          {
            id: 20,
            name: "刘禹兵",
            seniority: "1.5年",
            job: "行政管理中心网络管理员",
            glory: "优秀员工",
            motto: "时刻记住自己的责任，并以行动证明一切",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/20_fineStaff_lyb.png"),
          },
          {
            id: 21,
            name: "路晓莹",
            seniority: "4年",
            job: "专升本事业部市场部课程咨询部",
            glory: "优秀员工",
            motto: "执着于理想，纯粹于当下",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/21_fineStaff_lxy.png"),
          },
          {
            id: 22,
            name: "毛付先",
            seniority: "2年",
            job: "专升本网校项目部销售主管",
            glory: "优秀员工",
            motto: "没有失败，只有半途而废",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/22_fineStaff_mfx.png"),
          },
          {
            id: 23,
            name: "宁泽琪",
            seniority: "1年",
            job: "技术开发中心一运维工程师",
            glory: "优秀员工",
            motto: "不必想是否成功，既然选择远方，便只顾风雨兼程",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/23_fineStaff_nzq.png"),
          },
          {
            id: 24,
            name: "彭红超",
            seniority: "1.5年",
            job: "广东分校市场部",
            glory: "优秀员工",
            motto: "所谓的天花板就是没有天花板，不断突破，勇攀高峰",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/24_fineStaff_phc.png"),
          },
          {
            id: 25,
            name: "祁明明",
            seniority: "3.8年",
            job: "河北分校",
            glory: "优秀员工",
            motto: "目标再远大，终离不开信念去支撑",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/25_fineStaff_qmm.png"),
          },
          {
            id: 26,
            name: "申苗苗",
            seniority: "7年",
            job: "图书运营中心产品经理",
            glory: "优秀员工",
            motto: "认认真真工作，怀揣浪漫心态过平淡生活!",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/26_fineStaff_smm.png"),
          },
          {
            id: 27,
            name: "田丽",
            seniority: "4年",
            job: "专升本教学研究院讲师",
            glory: "优秀员工",
            motto: "心心在一艺，其艺必工",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/27_fineStaff_tl.png"),
          },
          {
            id: 28,
            name: "田文博",
            seniority: "2年",
            job: "专升本事业部VIP教学中心创新校区",
            glory: "优秀员工",
            motto: "心有猛虎，细嗅蔷薇",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/28_fineStaff_twb.png"),
          },
          {
            id: 29,
            name: "魏成龙",
            seniority: "1.5年",
            job: "图书运营中心高考数学策划",
            glory: "优秀员工",
            motto: "生命之灯因热情而点亮,生命之舟因拼搏而前行",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/29_fineStaff_wcl.png"),
          },
          {
            id: 30,
            name: "许锋",
            seniority: "1年",
            job: "技术开发中心IOS开发工程师",
            glory: "优秀员工",
            motto: "不要等待机会，而要创造机会",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/30_fineStaff_xf.png"),
          },
          {
            id: 31,
            name: "许千",
            seniority: "1年",
            job: "专升本事业部VIP教学中心新田校区",
            glory: "优秀员工",
            motto: "努力应该是没有边界的",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/31_fineStaff_xq.png"),
          },
          {
            id: 32,
            name: "杨力",
            seniority: "1年",
            job: "人力资源中心",
            glory: "优秀员工",
            motto: "知足且上进，温柔且锋利",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/32_fineStaff_yl.png"),
          },
          {
            id: 33,
            name: "姚彬",
            seniority: "3.5年",
            job: "专升本教学研究院线上高数讲师",
            glory: "优秀员工",
            motto: "性格决定命运，选择决定人生!",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/33_fineStaff_yb.png"),
          },
          {
            id: 34,
            name: "张蓓",
            seniority: "1年",
            job: "专升本事业部VIP教学中心北大学城校区",
            glory: "优秀员工",
            motto: "绳锯木断，水滴石穿",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/34_fineStaff_zb.png"),
          },
          {
            id: 35,
            name: "张畅",
            seniority: "1年",
            job: "技术开发中心UI设计师",
            glory: "优秀员工",
            motto: "放弃简单，但坚持一定很酷",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/35_fineStaff_zc.png"),
          },
          {
            id: 36,
            name: "张洋榜",
            seniority: "1.5年",
            job: "四川分校教学部",
            glory: "优秀员工",
            motto: "不经一番寒彻骨，怎得梅花扑鼻香",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/36_fineStaff_zyb.png"),
          },
          {
            id: 37,
            name: "张亦驰",
            seniority: "1年",
            job: "技术开发中心一JAVA开发工程师",
            glory: "优秀员工",
            motto: "聚沙成洲，奋发超越",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/37_fineStaff_zyc.png"),
          },
          {
            id: 38,
            name: "赵焕焕",
            seniority: "2年",
            job: "学历提升部",
            glory: "优秀员工",
            motto: "永不言败，是成功者的最佳品格",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/38_fineStaff_zhh.png"),
          },
          {
            id: 39,
            name: "赵婉",
            seniority: "5年",
            job: "教师事业部教务",
            glory: "优秀员工",
            motto: "不为失败找理由，只为成功找方法",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/39_fineStaff_zw.png"),
          },
          {
            id: 40,
            name: "朱松松",
            seniority: "1.2年",
            job: "技术开发中心Web开发工程师",
            glory: "优秀员工",
            motto: "只要路是对的，就不怕路远",
            img: require("@/assets/images/staffstyle/personstyle/2022/fineStaff/40_fineStaff_zss.png"),
          },
        ],
      },
    },
  },
  teamstyle: {
    year_2023: {
      fineTeam: {
        name: "团队风采",
        dataList: [],
      },
    },
    year_2022: {
      fineTeam: {
        name: "团队风采",
        dataList: [
          {
            id: 1,
            name: "专升本事业部-市场部",
            glory: "卓越贡献团队",
            motto: "过程是基础，结果论英雄",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/1_fineTeam_zsb.png"),
          },
          {
            id: 2,
            name: "专升本教学研究院-线下教学部",
            glory: "教学奉献团队",
            motto: "团结协作，务实笃行",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/2_fineTeam_zsb.png"),
          },
          {
            id: 3,
            name: "专升本教学研究院-线上教学教研部",
            glory: "教学奉献团队",
            motto: "线上线上，扶摇直上，永不言退，最佳团队",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/3_fineTeam_zsb.png"),
          },
          {
            id: 4,
            name: "教师事业部-直营校管理部",
            glory: "卓越贡献团队",
            motto: "今天付出，明天收获，全力以赴，业绩辉煌!",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/4_fineTeam_js.png"),
          },
          {
            id: 5,
            name: "教师事业部-教师教研中心",
            glory: "教学奉献团队",
            motto: "用努力、实力、活力创造生产力",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/5_fineTeam_js.png"),
          },
          {
            id: 6,
            name: "图书运营中心",
            glory: "卓越贡献团队",
            motto: "乘风破浪，奋发向上，图书有我，共创辉煌",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/6_fineTeam_ts.png"),
          },
          {
            id: 7,
            name: "专升本事业部-库课网校项目",
            glory: "卓越贡献团队",
            motto: "团结一切可以团结的力量，快速布局全国专升本市场",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/7_fineTeam_zsb.png"),
          },
          {
            id: 8,
            name: "技术开发中心-产品设计部",
            glory: "技术创新团队",
            motto: "墨守成规无异于坐以待毙，勇于创新方有无限可能",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/8_fineTeam_kf.png"),
          },
          {
            id: 9,
            name: "品牌中心",
            glory: "卓越服务团队",
            motto: "有信念不一定成功,没信念一定会失败",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/9_fineTeam_pp.png"),
          },
          {
            id: 10,
            name: "图书运营中心-广东分校",
            glory: "卓越贡献团队",
            motto: "市场开拓 广东最强 全力以赴 超越梦想",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/10_fineTeam_ts.png"),
          },
          {
            id: 11,
            name: "VIP教学中心-新田城校区",
            glory: "卓越服务团队",
            motto:
              "立足市场，服务学员，高标准，严要求，讲实效创一流业绩 创精品校区",
            img: require("@/assets/images/staffstyle/teamstyle/2022/fineTeam/11_fineTeam_vip.png"),
          },
        ],
      },
    },
  },
};
export const indexStaffStyle = {
  team: [
    {
      id: 1,
      img: require("@/assets/images/staffstyle/team_1_index.png"),
      name: "图书运营中心",
      glory: "当年荣誉：卓越贡献团队",
    },
    {
      id: 2,
      img: require("@/assets/images/staffstyle/team_2_index.png"),
      name: "教师事业部-教师教研中心",
      glory: "当年荣誉：教学奉献团队",
    },
    {
      id: 3,
      img: require("@/assets/images/staffstyle/team_3_index.png"),
      name: "技术开发中心-产品设计部",
      glory: "当年荣誉：技术创新团队",
    },
    {
      id: 4,
      img: require("@/assets/images/staffstyle/team_4_index.png"),
      name: "专升本事业部-市场部",
      glory: "当年荣誉：卓越贡献团队",
    },
  ],
  person: [
    {
      id: 1,
      img: require("@/assets/images/staffstyle/person_1_index.png"),
      name: "陈小勇",
      glory: "年度荣誉：2022年风雨同舟奖",
    },
    {
      id: 2,
      img: require("@/assets/images/staffstyle/person_2_index.png"),
      name: "王光庆",
      glory: "年度荣誉：劳动新模范",
    },
    {
      id: 3,
      img: require("@/assets/images/staffstyle/person_3_index.png"),
      name: "段志博",
      glory: "年度荣誉：库课新青年",
    },
    {
      id: 4,
      img: require("@/assets/images/staffstyle/person_4_index.png"),
      name: "赵霞",
      glory: "年度荣誉：2022年风雨同舟奖",
    },
  ],
};